import { Injectable } from '@angular/core';
import { ErrorModel } from 'src/app/core/models/error.model';
import { LocalStorage } from 'src/app/core/utils/local.storage';
import { ConfiguracaoService } from 'src/app/main/configuracao/services/configuracao.service';
import { UsuarioDTOModel } from '../models/usuario-dto.model';
import { LoginService } from 'src/app/core/services/login.service';

@Injectable({
  providedIn: 'root'
})
export class LoadUserDataService {

  constructor(
     private configuracaoService: ConfiguracaoService,
     private loginService: LoginService,
  ) {}

  get(): void {
    const auth: any = LocalStorage.getItem('usuario');
    if (!!auth.userEmail) {
      this.configuracaoService.findUser(auth.userEmail).subscribe((usuarioDTO: UsuarioDTOModel) => {
        this.loginService.setLoginData(usuarioDTO);
        LocalStorage.setItem('usuarioSistemaDTO', usuarioDTO);
      }, (error: ErrorModel) => {
        console.log(error);
      });
    }
  }
}
